export default "__VITE_ASSET__Bo7Dm$ua__"